export type Formats =
  | "DD-MM-YYYY"
  | "YYYY-MM-DD"
  | "DD-MM-YYYY h:mm A"
  | "MMM d, YYYY h:mm A"
  | "ago"
  | "MMMM D"
  | "MMMM";
export type DateType = Date | string | moment.Moment;

type DATE_FORMATS = {
  dateFirst: "DD-MM-YYYY";
  yearFirst: "YYYY-MM-DD";
};

export const DATE_FORMATS: DATE_FORMATS = {
  dateFirst: "DD-MM-YYYY",
  yearFirst: "YYYY-MM-DD",
};
